
export const GESTURES = [
    { name: 'smile', input: 'foto con sonrisa', type: 'SS', chances: 50 },
    { name: 'eyes-closed', input: 'foto con los ojos cerrados', type: 'SCE', chances: 50 },
    { name: 'left-wink', input: 'foto con guiño izquierdo', type: 'SBL', chances: 0 },
    { name: 'right-wink', input: 'foto con guiño derecho', type: 'SBR', chances: 0 },
]

export default GESTURES;